import { mediaById } from './media'
import type { Community } from '../types'

export const communities: Community[] = [
  {
    id: 'musculacao',
    name: { 'pt-BR': 'Musculação', 'en-US': 'Strength training' },
    description: {
      'pt-BR': 'Progressão de carga, técnica e consistência no treino de força.',
      'en-US': 'Load progression, technique and consistency in strength training.',
    },
    cover: mediaById('strength').url,
    categories: ['strength', 'workout'],
    members: 18420,
    postsThisWeek: 412,
    joinedByDefault: true,
  },
  {
    id: 'corrida',
    name: { 'pt-BR': 'Corrida', 'en-US': 'Running' },
    description: {
      'pt-BR': 'Do primeiro 5K à maratona, no seu ritmo.',
      'en-US': 'From the first 5K to the marathon, at your own pace.',
    },
    cover: mediaById('running').url,
    categories: ['running'],
    members: 24110,
    postsThisWeek: 638,
    joinedByDefault: true,
  },
  {
    id: 'crossfit',
    name: { 'pt-BR': 'CrossFit', 'en-US': 'CrossFit' },
    description: {
      'pt-BR': 'WODs, benchmarks e evolução em condicionamento.',
      'en-US': 'WODs, benchmarks and conditioning progress.',
    },
    cover: mediaById('strength').url,
    categories: ['crossfit'],
    members: 9870,
    postsThisWeek: 204,
    joinedByDefault: false,
  },
  {
    id: 'natacao',
    name: { 'pt-BR': 'Natação', 'en-US': 'Swimming' },
    description: {
      'pt-BR': 'Técnica, séries e águas abertas.',
      'en-US': 'Technique, sets and open water.',
    },
    cover: mediaById('swimming').url,
    categories: ['swimming'],
    members: 7340,
    postsThisWeek: 131,
    joinedByDefault: false,
  },
  {
    id: 'ciclismo',
    name: { 'pt-BR': 'Ciclismo', 'en-US': 'Cycling' },
    description: {
      'pt-BR': 'Estrada, montanha e treinos indoor.',
      'en-US': 'Road, mountain and indoor training.',
    },
    cover: mediaById('cycling').url,
    categories: ['cycling'],
    members: 11260,
    postsThisWeek: 257,
    joinedByDefault: false,
  },
  {
    id: 'triatlo',
    name: { 'pt-BR': 'Triatlo', 'en-US': 'Triathlon' },
    description: {
      'pt-BR': 'Natação, bike e corrida organizadas em um só ciclo.',
      'en-US': 'Swim, bike and run organized in a single cycle.',
    },
    cover: mediaById('swimming').url,
    categories: ['swimming', 'cycling', 'running'],
    members: 4180,
    postsThisWeek: 96,
    joinedByDefault: false,
  },
  {
    id: 'nutricao',
    name: { 'pt-BR': 'Nutrição', 'en-US': 'Nutrition' },
    description: {
      'pt-BR': 'Refeições reais, rotina e hidratação.',
      'en-US': 'Real meals, routine and hydration.',
    },
    cover: mediaById('nutrition').url,
    categories: ['nutrition'],
    members: 15930,
    postsThisWeek: 344,
    joinedByDefault: false,
  },
  {
    id: 'mindfulness',
    name: { 'pt-BR': 'Mindfulness', 'en-US': 'Mindfulness' },
    description: {
      'pt-BR': 'Respiração, pausa e clareza mental.',
      'en-US': 'Breathing, pause and mental clarity.',
    },
    cover: mediaById('mindfulness').url,
    categories: ['mindfulness'],
    members: 12470,
    postsThisWeek: 188,
    joinedByDefault: true,
  },
  {
    id: 'mobilidade',
    name: { 'pt-BR': 'Mobilidade', 'en-US': 'Mobility' },
    description: {
      'pt-BR': 'Alongamento, recuperação e movimento sem dor.',
      'en-US': 'Stretching, recovery and pain-free movement.',
    },
    cover: mediaById('recovery').url,
    categories: ['lifestyle'],
    members: 6210,
    postsThisWeek: 87,
    joinedByDefault: false,
  },
]

export function findCommunity(id: string): Community | undefined {
  return communities.find((community) => community.id === id)
}
